/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Car\CarList\CarList.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Monday March 25th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 25th 2024 2:48:22 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { SyntheticEvent, useEffect, useMemo, useState } from "react";
import { useLoaderData } from "react-router-dom";
import translator from "MultiLanguage/TranslationWrapper";
import SeenCarComponent from "Content/SeenCar/SeenCarComponent";
import CollapseBox from "Content/CollapseBox/CollapseBox";
import SeenCarService from "Services/SeenCar/SeenCar.service";
import { Tab, Tabs } from "@mui/material";
import { CustomTabPanel } from "Content/Stats/Stats";
import CarListRow from "../CarListRow/CarListRow";
import { indexOf } from "lodash-es";
import CarService from "Services/Car/CarService";
import SearchByTerm from "Content/Search/SearchByTerm";

type DataType = {
    tabkey?: string
}

function CarList(_: any) {
    const loadData: DataType = useLoaderData() as DataType;
    const [views, setViews] = useState(0);

    const tabIdx = ["stock", "selling", "sold", "reserved", "archived"];
    const [value, setValue] = useState(loadData.tabkey ? indexOf(tabIdx, loadData.tabkey) : 0);
    const [result, setResult] = useState<{label: String, result: any}[] | null>(null);

    useEffect(() => {
        SeenCarService.totalViews().then((result) => {
            setViews(result.data);
        }).catch(() => {
            setViews(0);
        });
    }, []);

    const handleChange = (event: SyntheticEvent, idx: number) => {
        setValue(idx);
        const url = window.location;
        const searchParams = new URLSearchParams(url.search);
        searchParams.set("tabkey", tabIdx[idx]);
        window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
    };

    const buildTabs = () => {
        const tabs: JSX.Element[] = [];
        for (let i = 0; i < tabIdx.length; ++i)
            tabs.push(<Tab value={i} label={translator.decode(`Status.${tabIdx[i]}`)} />);
        return tabs;
    };

    const buildRows = () => {
        const rows: JSX.Element[] = [];
        for (let i = 0; i < tabIdx.length; ++i)
            rows.push(<CustomTabPanel key={`tabPanel-${tabIdx[i]}`} value={value} index={i} >
                <CarListRow Status={tabIdx[i]} FilteredCars={result ? result.map(v => v.result) : null} />
            </CustomTabPanel>);
        return rows;
    };
    const carListPage = useMemo(() => {        
        return buildRows();
    }, [value, result]);

    const buildSearchBar = () => {
        return <SearchByTerm searchFunc={CarService.getCarBySearch} secondArg={tabIdx[value]} setResult={setResult}  title={translator.decode("table.headers.Car")} />
    }

    const carSearchBar = useMemo(() => {
        return buildSearchBar();
    }, [value, result]);


    return(
        <div className="d-flex p-3 flex-column justify-content-between">
            <CollapseBox class={"mb-3"} textBtn={`${translator.decode("dynamic.views")} ${views}`}>
                <SeenCarComponent showTimeFilter={false}/>
            </CollapseBox>
            {carSearchBar}
            <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto" textColor="primary" indicatorColor="primary" >
                {buildTabs()}
            </Tabs>
            {carListPage}
        </div>
    );
}

export default CarList;
